<template>
    <section aria-hidden="false" aria-labelledby="steps-uid-6-h-0" class="body current" id="steps-uid-6-p-0" role="tabpanel">
        <form @submit.prevent="validate">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="commodities">Commodity</label>
                        <a id="commodities" class="ml-4" data-target="#searchAndSelectCommodityModal" data-toggle="modal"
                           href="javascript:void(0)"><b>Click here to
                            add commodity</b></a>
                        <ul v-if="commodity.id" class="ml-3">
                            <li>{{commodity.name}} <span
                                    v-if="commodity.code">({{commodity.code}})</span> -
                                {{commodity.variety}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Speciality</label>
                        <div class="form-check">
                            <input :class="{'is-invalid': submitted && errors.has('special_quality')}"
                                   @click="setQuality('NONGMO')"
                                   class="form-check-input"
                                   data-vv-as="special_quality"
                                   id="nongmo"
                                   name="special_quality"
                                   type="checkbox"
                                   v-model="commodity.special_quality"
                                   v-validate="'required'"
                                   value="NONGMO">
                            <label class="form-check-label" for="nongmo">Non-GMO</label>
                        </div>
                        <div class="form-check">
                            <input :class="{'is-invalid': submitted && errors.has('special_quality')}"
                                   @click="setQuality('ORGANIC')"
                                   class="form-check-input"
                                   data-vv-as="special_quality"
                                   id="organic"
                                   name="special_quality"
                                   type="checkbox"
                                   v-model="commodity.special_quality"
                                   v-validate="'required'"
                                   value="ORGANIC">
                            <label class="form-check-label" for="organic">Organic</label>
                        </div>
                        <div class="form-check">
                            <input :class="{'is-invalid': submitted && errors.has('special_quality')}"
                                   @click="setQuality('IP')"
                                   class="form-check-input"
                                   data-vv-as="special_quality"
                                   id="ip"
                                   name="special_quality"
                                   type="checkbox"
                                   v-model="commodity.special_quality"
                                   v-validate="'required'"
                                   value="IP">
                            <label class="form-check-label" for="ip">IP</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Harvest Year</label>
                        <div :key="year" @click="setYear(year)" class="form-check" v-for="year in years">
                            <input :class="{'is-invalid': submitted && errors.has('harvest_year')}"
                                   :id="year"
                                   :value="year"
                                   class="form-check-input"
                                   data-vv-as="harvest_year"
                                   name="harvest_year"
                                   type="radio"
                                   v-model="commodity.year"
                                   v-validate="'required'">
                            <label :for="year" @click="setYear(year)" class="form-check-label">
                                {{year}}
                            </label>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8">
                    <div class="form-group">
                        <label for="audit">Audits</label>
                        <multiselect :class="{'is-invalid': submitted && errors.has('audit')}"
                                     :options="audits"
                                     class="form-control"
                                     id="audit"
                                     label="audit"
                                     name="audit"
                                     open-direction="top"
                                     placeholder="Select Audits"
                                     v-model="commodity.audit">
                            <template slot="singleLabel" slot-scope="props">
                                <h5>{{props.option.title}} audit for {{props.option.coop_name}}</h5>
                                <span>Audited By {{props.option.auditor.org_name}} on {{props.option.created_on | medium}}</span>
                            </template>
                            <template slot="option" slot-scope="props">
                                <h5>{{props.option.title}} audit for {{props.option.coop_name}}</h5>
                                <span>Audited By {{props.option.auditor.org_name}} on {{props.option.created_on | medium}}</span>
                            </template>
                        </multiselect>
                        <div class="invalid-feedback" v-if="submitted && errors.has('audit')">{{ errors.first('audit') }}</div>
                    </div>
                </div>
            </div>
        </form>

        <search-select-commodity :checked-commodity-ids="commodityIds" :single-select="true"
                                 @commodity-select="setCommodity"></search-select-commodity>
    </section>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from 'vuex';
    import SearchSelectCommodity from "../../../common/SearchSelectCommodity";

    export default {
        name: "AllOffers",
        components: {SearchSelectCommodity, Multiselect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                isLoading: false,
                submitted: false,
                commodity: this.$parent.commodity,
                commodityIds: this.$parent.commodityIds,
                years: this.$parent.years,
                commodity_list: [],
                grades: [
                    {value: 'A', text: 'A'},
                    {value: 'B', text: 'B'},
                    {value: 'C', text: 'C'},
                    {value: 'D', text: 'D'}
                ],
                audits: [],
            };
        },
        mounted() {
            this.getAudits();
            this.commodityIds = this.$parent.commodityIds;
        },
        methods: {
            setQuality(quality) {
            },
            setYear(year) {
                this.commodity.year = year;
            },
            async validate() {
                this.submitted = true;
                let valid      = await this.$validator.validate();
                if(this.commodityIds.length === 0){
                    await this.$swal({
                        type: 'error',
                        title: 'Commodity not selected',
                        text: 'Please select at least one commodity',
                        timer: 5000
                    });
                    return false;
                }
                return valid;
            },
            async getAudits() {
                let reply = await this.$http.get(`/integrations/audits`);
                this.audits = reply.data;
            },
            setCommodity(e) {
                let commodity = e.length > 0 ? e[0] : null;
                if(commodity) {
                    this.commodity.id = commodity.id;
                    this.commodity.commodity_id = commodity.id;
                    this.commodity.name = commodity.name;
                    this.commodity.code = commodity.code;
                    this.commodity.variety = commodity.variety;
                    this.commodity.grade = commodity.commodity_props ? commodity.commodity_props.grade : null;
                    this.$parent.commodityIds = this.commodityIds = [commodity.id];
                }
            }
        }
    }
</script>

<style scoped>
    .invalid-feedback {
        display: block;
    }
</style>
